import { Box, useTheme } from "@mui/material";
import React from "react";

const PrimaryIcon = ({
  icon,
  color = "secondary",
  height = "20px",
  width = "20px",
  className = "",
  fill = true,
  cursor = "default",
  variant = "main",
  flipX = false,
  flipY = false,
}) => {
  const theme = useTheme();

  let fillColor = theme.palette?.[color]?.[variant];
  let transform = "";
  if (flipX) transform = "scaleX(-1)";
  if (flipY) transform = "scaleY(-1)";

  return React.createElement(icon, {
    ...(fill && {
      fill: fillColor,
    }),
    height,
    width,
    className,
    style: { transition: "fill 0.3s ease", minWidth: width, cursor, color: fillColor, transform },
  });
};

export default PrimaryIcon;
